import React from "react";
import FormAsyncTC from "../../../components/Forms/FormAsyncTC";
import { useFormContext } from "react-hook-form";
import FormJson from "../../../components/Forms/FormJson";

export default function CustomizableArticles() {
  const { menukaartVestigingId } = useFormContext();

  return (
    <>
      <FormAsyncTC
        async={{
          url:
            "core/producten/search?fields=id as value, naam as label&per_page=50&sort_field=naam&vestiging_id=" +
            menukaartVestigingId,
          searchField: "naam",
        }}
        key={"custom_data.customizable_articles" + menukaartVestigingId}
        multiple
        name={"custom_data.customizable_articles"}
        tDefault={"Articles used for unknowns"}
        tKey={"custom_data.customizable_articles"}
      />
      <FormAsyncTC
        async={{
          url:
            "core/producten/search?fields=id as value, naam as label&per_page=50&sort_field=naam&vestiging_id=" +
            menukaartVestigingId,
          searchField: "naam",
        }}
        key={"custom_data.notification_article" + menukaartVestigingId}
        name={"custom_data.notification_article"}
        tDefault={"Article used for notifications"}
        tKey={"custom_data.notification_article"}
      />
      <FormJson name={"custom_data.employee_codes"} tDefault={"Employee codes"} tKey={"Employee codes"} />
    </>
  );
}
